import { render, staticRenderFns } from "./Liste.vue?vue&type=template&id=b01223ba"
import script from "./Liste.vue?vue&type=script&lang=js"
export * from "./Liste.vue?vue&type=script&lang=js"
import style0 from "./Liste.vue?vue&type=style&index=0&id=b01223ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports